import differenceInYears from 'date-fns/differenceInYears';

export default function (birthDate: string): number | undefined {
  return birthDate ? differenceInYears(new Date(), new Date(birthDate)) : undefined;
}
